import clsx from 'clsx';
import { observer } from 'mobx-react';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../../../../Types';
import Store from '../../../Store';
import { ExperienceResource } from '../../../Types';
import BodyRight from './BodyRight';
import BodyLeft from './BodyLeft';
import { when } from '@execonline-inc/maybe-adapter';
import { equals } from 'ramda';

interface Props {
  store: Store;
  resource: ExperienceResource;
  context: ModifiableExperiencesContext;
  learningCollectionStore: LearningCollectionEditStore;
}

function Body({ learningCollectionStore, resource, context, store }: Props) {
  return (
    <div
      className={clsx(
        'border-gray-20 flex',
        learningCollectionStore
          .selectedExperience(context, resource)
          .andThen(() => when(equals(resource.payload.status), 'Unlicensed'))
          .map(() => 'opacity-50')
          .getOrElseValue(''),
      )}
    >
      <BodyLeft
        resource={resource}
        learningCollectionStore={learningCollectionStore}
        productLicense={store.selectedProductLicense}
      />
      <BodyRight resource={resource} />
    </div>
  );
}

export default observer(Body);
